import routes from '@/modules/home/home-routes';
import store from '@/modules/home/home-store';

export default {
  routes,
  store
};
